import { render, staticRenderFns } from "./ImageColumn.vue?vue&type=template&id=3bae3165&scoped=true&"
import script from "./ImageColumn.vue?vue&type=script&lang=js&"
export * from "./ImageColumn.vue?vue&type=script&lang=js&"
import style0 from "./ImageColumn.vue?vue&type=style&index=0&id=3bae3165&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae3165",
  null
  
)

export default component.exports